// The unit price of the product that was just added, read from the cart the
// add returned. Quick-add tracking has no product object to take a price
// from, and the Meta Pixel AddToCart event is only valid with a value.
const getAddedItemPrice = (cart, idProduct) => {
  const item = cart?.items?.find(
    (cartItem) => String(cartItem?.id_product) === String(idProduct),
  )

  return item?.prices?.discounted_price ?? item?.prices?.original_price
}

export default getAddedItemPrice
